import { lazy } from "react";
import type { ComponentType } from "react";
import type { PublicMenuLayoutId } from "../../../shared/public-menu-theme";
import { DefaultPublicMenuLayout } from "./DefaultPublicMenuLayout";
import type { PublicMenuController } from "./usePublicMenuController";

export type PublicMenuLayoutComponent = ComponentType<{ controller: PublicMenuController }>;

// Keep client-specific presentation and CSS out of the initial default menu chunk.
const WingersLayout = lazy(() => import("./WingersPublicMenuLayout").then((module) => ({ default: module.WingersPublicMenuLayout })).catch(() => ({ default: DefaultPublicMenuLayout })));
const DinnerKingLayout = lazy(() => import("./DinnerKingPublicMenuLayout").then((module) => ({ default: module.DinnerKingPublicMenuLayout })).catch(() => ({ default: DefaultPublicMenuLayout })));

const PUBLIC_MENU_LAYOUT_REGISTRY = {
  default: DefaultPublicMenuLayout,
  wingers: WingersLayout,
  dinnerking: DinnerKingLayout,
} satisfies Record<PublicMenuLayoutId, PublicMenuLayoutComponent>;

export function getPublicMenuLayout(layoutId: string | null | undefined): PublicMenuLayoutComponent {
  // Do not allow inherited property names such as constructor or __proto__.
  if (layoutId && Object.hasOwn(PUBLIC_MENU_LAYOUT_REGISTRY, layoutId)) {
    return PUBLIC_MENU_LAYOUT_REGISTRY[layoutId as PublicMenuLayoutId];
  }
  return DefaultPublicMenuLayout;
}
